import React from 'react';
import { useSelector } from 'react-redux';
import { useFeatureFlag } from '../../../../_hooks/useFeatureFlag';
import { useIsEmbeddedMobile } from '../../../../_hooks/useIsEmbeddedMobile';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { WrapperProps } from '../../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Feature } from '../../../../CommonSelectors/CommonArea.types';
import { showTransactionsSelector } from '../../../../CommonSelectors/CommonAreaSelector';
import { useRouteParams } from '../../../hooks/useRouteParams';
import { TabSlug } from '../../../types';
import { Wrapper } from './ActivityDetailsLink.styles';

interface Props extends WrapperProps {}

export const ActivityDetailsLink = (props: Props) => {
  const routeParams = useRouteParams();

  const isEmbeddedMobile = useIsEmbeddedMobile();

  const showTransactions = useSelector(showTransactionsSelector);

  const showActivityDetails = useFeatureFlag(Feature.ActivityDetails);

  if (!showTransactions) {
    return null;
  }

  if (!showActivityDetails) {
    return null;
  }

  const onClick = () =>
    ADV.util.Router.go2('AccountPerformanceReporting', {
      ...routeParams,
      tabSlug: TabSlug.Activity,
    });

  return (
    <Wrapper {...props} isEmbeddedMobile={isEmbeddedMobile}>
      <Button
        variant="link"
        variantColor="neutral"
        onClick={onClick}
        rightIcon="fas fa-chevron-right"
      >
        Activity Details
      </Button>
    </Wrapper>
  );
};
